import { useEffect, useState, useRef, useCallback } from "react"
import ScrollToTop from "react-scroll-to-top"
import Headermain from "../header"
import { About } from "./about"
import { Home } from "./home"
import { Impress } from "./impress"
import { Portfolio } from "./portfolio"

export const Summary = (props) => {
    const [tab, setTab] = useState(0)
    const scrollRef = useRef(null)

    const executeScroll = useCallback(() => {
        scrollRef.current?.scrollIntoView({ behavior: "smooth" })
        if (tab !== 3 && tab !== 4 && tab !== 2) {
            setTab()
        }
    }, [tab])

    const navigate = (e) => {
        setTab(e)
    }

    useEffect(() => {
        executeScroll()
    }, [tab, executeScroll
    ])

    const onAboutUsClick = () => {
        navigate(3)
    }

    const onPortfolioClick = () => {
        navigate(2)
    }

    return (
        <>
            <Headermain onClick={navigate} />

            {(tab !== 4 && tab !== 3 && tab !== 2) &&
                <>
                    <div style={{ scrollMarginTop: '60px' }} ref={tab === 1 ? scrollRef : null}>
                        <Home onAboutUsClick={onAboutUsClick} onPortfolioClick={onPortfolioClick} />
                    </div>
                </>
            }

            {tab === 2 &&
                <>
                    <div style={{ scrollMarginTop: '60px' }} ref={tab === 2 ? scrollRef : null}>
                        <Portfolio />
                    </div>
                </>
            }

            {tab === 3 &&
                <>
                    <div style={{ scrollMarginTop: '60px' }} ref={tab === 3 ? scrollRef : null}>
                        <About />
                    </div>
                </>
            }

            {tab === 4 &&
                <>
                    <div style={{ scrollMarginTop: '60px' }} ref={tab === 3 ? scrollRef : null}>
                        <Impress />
                    </div>
                </>
            }

            <ScrollToTop smooth />
        </>
    )
}